import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
// 1. On importe tes jeux manuels
import { games as initialGames } from "../data/games";

function SearchBar() {
  const [input, setInput] = useState("");
  const [results, setResults] = useState([]);
  const [allData, setAllData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const loadSearchData = async () => {
      try {
        const gamesSnap = await getDocs(collection(db, "games"));
        const articlesSnap = await getDocs(collection(db, "articles"));
        
        const firebaseGames = gamesSnap.docs.map(doc => ({ 
          id: doc.id, 
          ...doc.data(), 
          type: 'game' 
        }));

        const firebaseArticles = articlesSnap.docs.map(doc => ({ 
          ...doc.data(), 
          type: 'article' 
        }));

        // 2. FUSION : Firebase + Tes jeux manuels
        const combined = [
          ...firebaseGames,
          ...initialGames.map(g => ({ ...g, type: 'game' })), // On ajoute le type 'game' aux manuels
          ...firebaseArticles
        ];
        
        setAllData(combined);
      } catch (error) {
        console.error("Erreur recherche:", error);
        // En cas d'erreur, on garde au moins les jeux manuels
        setAllData(initialGames.map(g => ({ ...g, type: 'game' })));
      }
    };
    loadSearchData();
  }, []);

  useEffect(() => {
    if (input.length > 1) {
      const filtered = allData.filter(item => 
        item.title?.toLowerCase().includes(input.toLowerCase())
      ).slice(0, 5);
      setResults(filtered);
    } else {
      setResults([]);
    }
  }, [input, allData]);

  const handleSelect = (item) => {
    setInput("");
    setResults([]);
    if (item.type === 'game') {
      navigate(`/game/${item.id}`);
    } else {
      navigate(`/article/${item.slug}`);
    }
  };

  return (
    <div className="search-wrapper-container" style={{ position: "relative", width: "250px" }}>
      <input
        type="text"
        placeholder="Trouver un jeu..."
        value={input}
        onChange={(e) => setInput(e.target.value)}
        className="premium-search-input"
      />
      
      {results.length > 0 && (
        <div className="search-dropdown-results">
          {results.map((item, index) => (
            <div 
              key={index} 
              onClick={() => handleSelect(item)}
              className="search-suggestion-item"
            >
              <span className="search-icon-type">
                {item.type === 'game' ? "🎮" : "📄"}
              </span>
              {item.title}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default SearchBar;